import { UserProfile } from '@clerk/clerk-react';
import { css } from '@styled-system/css';
import { center } from '@styled-system/patterns';
import { useNavigate } from 'react-router-dom';

import { RoundedCloseButton } from '@/shared/components/ui/RoundedCloseButton';

export const ManageUserAccountPage = () => {
  const navigate = useNavigate();

  const backgroundGradientStyles = css({
    position: 'fixed',
    top: '-10vh',
    left: '-50vmin',
    w: '110vmin',
    h: '110vmin',
    background: 'radial-gradient(circle, rgba(94, 105, 211, 0.3) 0%, transparent 70%)',
    pointerEvents: 'none',
    zIndex: 0,
  });

  const closeButtonStyles = css({
    position: 'fixed',
    top: '1.9375rem',
    right: '1.9375rem',
  });

  return (
    <div
      className={center({
        w: '100vw',
        minH: '100vh',
        overflow: 'auto',
      })}
    >
      <div className={backgroundGradientStyles} />
      <UserProfile routing="virtual" />
      <RoundedCloseButton className={closeButtonStyles} onClick={() => navigate('/')} />
    </div>
  );
};
